import { UserInfo } from './UserInfo';

export default function AccountSettings() {
  return <UserInfo />;
}
